import React, {useState} from "react";
import {observer} from "mobx-react";
import PropTypes from "prop-types";
import {permissionsEnum} from '../../serverClientShared/sharedEnums';
import './dragDrop.scss';
import {useStores} from "../../Hooks";

const Drop = observer(props => {
    const {dragStore, projectStore} = useStores();
    const {itemId} = props;
    const [hovered, setHovered] = useState(false);
    const isDisabled = props.isDisabled
        || !projectStore.checkAllowedCurrentProject(permissionsEnum.MOVE_AND_DELETE_ITEMS, false)
        || dragStore.dragItemId === itemId;

    async function leave() {
        if (isDisabled) {
            return;
        }
        setHovered(false);
        dragStore.dropItemId = null;
    }

    async function enter() {
        if (isDisabled) {
            return;
        }
        if (dragStore.dragItemId) {
            dragStore.dropItemId = itemId;
            setHovered(true);
        }
    }

    function getHoveredClass() {
        return hovered && dragStore.dragItemId ? 'hovered' : '';
    }

    return (
        <div
            onMouseEnter={enter}
            onMouseLeave={leave}
            className={'drop ' + getHoveredClass()}
        >
            {props.children}
        </div>
    )
})

Drop.propTypes = {
    itemId: PropTypes.string.isRequired,
};
export default Drop;
